<template>
    <div class="rounded-pill p-1 px-2 text-center" :class="`bg-${statusSet[status].color}`">
        <span class="fw-bold" :class="`text-${statusSet[status].contrast}`">{{ statusSet[status].name }}{{ isActive ? '...' : '' }}</span>
    </div>
</template>

<script>
export default {
    props: {
        status: {
            type: String,
            required: true
        }
    },
    computed: {
        isActive() {
            return ["pending", "in_progress"].includes(this.status);
        },
        statusSet() {
            return {
                complete: {
                    color: "success",
                    name: this.t("importHistory-statusComplete"),
                    contrast: "white",
                },
                cancelled: {
                    color: "danger",
                    name: this.t("importHistory-statusCancelled"),
                    contrast: "white",
                },
                in_progress: {
                    color: "primary",
                    name: this.t("importHistory-statusInProgress"),
                    contrast: "white",
                },
                pending: {
                    color: "warning",
                    name: this.t("importHistory-statusPending"),
                    contrast: "black",
                },
                failed: {
                    color: "danger",
                    name: this.t("importHistory-statusFailed"),
                    contrast: "white",
                },
            };
        },
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
    }
}
</script>
